import pluralize from 'pluralize';
import { memo } from 'react';

import { FileStatusIconCompleted, FileStatusTitle } from '@air/feature-file-status/ui';

import { getTaskPaneFileStatusIconSize } from '~/components/FileStatusTrackingPane/getTaskPaneFileStatusIconSize';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { TaskPaneDismissButton } from '~/components/FileStatusTrackingPane/TaskPaneDismissButton';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';
import { type AssetCustomFieldValueUpdateTask, type GetCompletedMetadata } from '~/store/tasks/types';

export type AssetCustomFieldValueUpdateTaskCompletedPanelItemProps = {
  metadata: GetCompletedMetadata<AssetCustomFieldValueUpdateTask>;
  onClear: () => void;
};

export const AssetCustomFieldValueUpdateTaskCompletedPanelItem = memo(
  ({ metadata, onClear }: AssetCustomFieldValueUpdateTaskCompletedPanelItemProps) => {
    const { ui2026 } = useTemporaryFeatureFlags();
    const updatedCount = metadata.updatedAssetsCount ?? metadata.assetIds?.length ?? 0;

    return (
      <PaneItemTW
        avatar={<FileStatusIconCompleted size={getTaskPaneFileStatusIconSize(ui2026)} />}
        title={
          <FileStatusTitle data-testid="ASSET_CUSTOM_FIELD_VALUE_UPDATE_TASK_COMPLETED_PANEL_ITEM_TITLE">
            Custom fields updated
          </FileStatusTitle>
        }
        subtitle={
          updatedCount > 0 ? (
            <span className="ads:text-secondary text-12 text-gray-11">
              {pluralize('asset', updatedCount, true)} updated
            </span>
          ) : undefined
        }
        buttons={<TaskPaneDismissButton label="Clear" onClick={onClear} />}
      />
    );
  },
);

AssetCustomFieldValueUpdateTaskCompletedPanelItem.displayName = 'AssetCustomFieldValueUpdateTaskCompletedPanelItem';
